import { parseU64OrZero } from "@bridgesplit/utils";

import {
    LendVaultActivityActionTypeApi,
    LendVaultActivityItemApi,
    LendVaultActivityResponseApi
} from "../api/lend-vault-activity";
import { LendVaultActivityItem, LendVaultActivityResponse } from "../domain/lend-vault-activity";
import { VaultActionType } from "../vault";

function parseLendVaultActivityActionType(actionType: LendVaultActivityActionTypeApi): VaultActionType {
    return actionType === "withdrawal" ? VaultActionType.Withdrawal : VaultActionType.Deposit;
}

function parseLendVaultActivityItemFromApi(api: LendVaultActivityItemApi): LendVaultActivityItem {
    return {
        actionType: parseLendVaultActivityActionType(api.actionType),
        amount: parseU64OrZero(api.amount),
        timestamp: api.timestamp,
        vaultAddress: api.vaultAddress,
        owner: api.owner,
        txSignature: api.txSignature
    };
}

export function parseLendVaultActivityResponseFromApi(api: LendVaultActivityResponseApi): LendVaultActivityResponse {
    return {
        items: api.items?.map(parseLendVaultActivityItemFromApi) ?? [],
        pageInfo: api.pageInfo
    };
}
